import request from '@/util/request';

// export async function getBase(orderNum: string) {
//   return await request.get(`/api/orders/${orderNum}/base`);
// }

export async function getAttachments(id: number) {
  return await request.get(`/api/orders/${id}/attachments`);
}

export async function getMix(id: number) {
  return await request.get(`/gapi/orders/${id}/mix`);
}
